import { functions, httpsCallable } from '../firebaseConfig.js';

const q1RegistrationFunctions = {
  checkForExistingMember: httpsCallable(functions, 'registration-checkForExistingMember'),
  newMember: httpsCallable(functions, 'registration-newMember'),
  sendClaimCode: httpsCallable(functions, 'registration-sendClaimCode'),
  verifyClaimCode: httpsCallable(functions, 'registration-verifyClaimCode'),
  claimMember: httpsCallable(functions, 'registration-claimMember'),
};

const q1VerificationFunctions = {
  resetVerificationCode: httpsCallable(functions, 'verification-resetVerificationCode'),
  processVerificationCode: httpsCallable(functions, 'verification-processVerificationCode'),
  removeEmail: httpsCallable(functions, 'verification-removeEmail'),
  addEmail: httpsCallable(functions, 'verification-addEmail'),
  setPrimaryEmail: httpsCallable(functions, 'verification-setPrimaryEmail'),
  changePhone: httpsCallable(functions, 'verification-changePhone'),
};

const q1PasswordFunctions = {
  initiateResetByEmail: httpsCallable(functions, 'password-initiateResetByEmail'),
  initiateResetByAuth: httpsCallable(functions, 'password-initiateResetByAuth'),
  verifyResetCode: httpsCallable(functions, 'password-verifyResetCode'),
  processReset: httpsCallable(functions, 'password-processReset'),
  changePassword: httpsCallable(functions, 'password-changePassword'),
};

const q1LogItemFunctions = {
  browseLogItems: httpsCallable(functions, 'log_item-browseLogItems'),
  getHistory: httpsCallable(functions, 'log_item-getHistory'),
};

const q1MemberFunctions = {
  getCurrentMember: httpsCallable(functions, 'member-getCurrentMember'),
  getMemberProfile: httpsCallable(functions, 'member-getMemberProfile'),
  browseMembers: httpsCallable(functions, 'member-browseMembers'),
  removeCurrentMemberFlag: httpsCallable(functions, 'member-removeCurrentMemberFlag'),
};

const q1MembershipFunctions = {
  browseMemberships: httpsCallable(functions, 'membership-browseMemberships'),
};

const q1TutorialFunctions = {
  getAllTutorialsBySection: httpsCallable(functions, 'tutorial-getAllTutorialsBySection'),
  trackView: httpsCallable(functions, 'tutorial-trackView'),
  markCompleted: httpsCallable(functions, 'tutorial-markCompleted'),
};

const q1OnboardingFunctions = {
  completeOnboarding: httpsCallable(functions, 'onboarding-completeOnboarding'),
};

const q1AgreementFunctions = {
  getOrCreateContributorUpgrade: httpsCallable(functions, 
    'agreement-getOrCreateContributorUpgrade'
  ),
  getAgreement: httpsCallable(functions, 'agreement-getAgreement'),
  getMyAgreements: httpsCallable(functions, 'agreement-getMyAgreements'),
  trackResponse: httpsCallable(functions, 'agreement-trackResponse'),
  deleteMyAgreement: httpsCallable(functions, 'agreement-deleteMyAgreement'),
}

const q1DocFunctions = {
  createDoc: httpsCallable(functions, 'doc-createDoc'),
  updateDoc: httpsCallable(functions, 'doc-updateDoc'),
  getDoc: httpsCallable(functions, 'doc-getDoc'),
};

const q1CacheFunctions = {
  getCache: httpsCallable(functions, 'cache-getCache'),
};

const q1VersionFunctions = {
  proposeNewDoc: httpsCallable(functions, 'version-proposeNewDoc'),
  proposeNewVersion: httpsCallable(functions, 'version-proposeNewVersion'),
  respond: httpsCallable(functions, 'version-respond'),
  getVersionHistory: httpsCallable(functions, 'version-getVersionHistory'),
};

const q1ExternalResourceFunctions = {
  browseExternalResources: httpsCallable(functions, 'external_resource-browseExternalResources'),
};

export {
  q1RegistrationFunctions,
  q1VerificationFunctions,
  q1PasswordFunctions,
  q1LogItemFunctions,
  q1MemberFunctions,
  q1MembershipFunctions,
  q1TutorialFunctions,
  q1OnboardingFunctions,
  q1AgreementFunctions,
  q1DocFunctions,
  q1CacheFunctions,
  q1VersionFunctions,
  q1ExternalResourceFunctions,
};
